export default "__VITE_ASSET__BKFh3JaP__"